export default __webpack_public_path__ + "static/media/image-chair-algo-d-2-a-w.08b246a4.png";